import * as actionTypes from './actionTypes';

export const setDarkTitleBarContent = (pageTitle, showActionbutton, actionButtontext, actionButtonIcon, currentCase, caseStatus) => ({
  type: actionTypes.SET_DARK_TITLEBAR_CONTENT,
  pageTitle,
  showActionbutton,
  actionButtontext,
  actionButtonIcon,
  currentCase,
  caseStatus
})

export const setDarkTitleCurrentCase = currentCase =>  ({
  type: actionTypes.SET_DARK_TITLE_CURRENT_CASE,
  currentCase
})

export const updateDarkTitleBarCaseStatus = caseStatus => ({
  type: actionTypes.UPDATE_DARK_TITLE_BAR_CASE_STATUS,
  caseStatus
})

export const hideActionButton = () => ({
  type: actionTypes.HIDE_ACTION_BUTTON
})

export const showDarkTitleBarActionModal = () => ({
  type: actionTypes.SHOW_DARK_TITLE_BAR_ACTION_MODAL
})

export const hideDarkTitleBarActionModal = () => ({
  type: actionTypes.HIDE_DARK_TITLE_BAR_ACTION_MODAL
})

export const setLanguage = lang => ({
  type:actionTypes.SET_LANGUAGE,
  lang
})

export const setLanguageFlag = flag => ({
  type:actionTypes.SET_LANGUAGE_FLAG,
  flag
})

export const setTranslatedData = translatedData => ({
  type: actionTypes.SET_TRANSLATED_DATA,
  translatedData
})

export const setHeaderDetails = (lastLogin, logOff) =>({
  type: actionTypes.SET_HEADER_DATA,
  lastLogin,
  logOff
})

export const setFooterDetails = (termsCondition, privacyPolicy, cookie) =>({
  type: actionTypes.SET_FOOTER_DATA,
  termsCondition,
  privacyPolicy,
  cookie
})
export const customerIncorrectCredentials = flag => ({
  type:actionTypes.SET_INCORRECT_CUSTOMER,
  flag
})

export const restCustomerIncorrectCredentials = () => ({
  type: actionTypes.RESET_INCORRECT_CUSTOMER
})

export const  getDarkTitleBarFlagOnPassword = (flag) => ({
  type: actionTypes.SET_DARK_FLAG_PSWD,
  flag
})



// WEBPACK FOOTER //
// ./src/components/layouts/actions/actionCreator.js